/**
 * Compares the selected date if earlier or beyond from the date provided
 */
export default ({ value }, percentLimit) => {
  let pass = true;
  pass = validatePercent(value, percentLimit);

  return pass;
};

const validatePercent = (value, compare) => {
  const percent = compare - value;

  return !(percent < 0);
};
